import { Component } from '@verndale/core';
import GenericDialog from './generic-dialog';

class ModalLinkButton extends Component {
  setupDefaults() {
    this.dom = {
      modal: document.querySelector('.generic-dialog') as HTMLElement
    };

    if (this.dom.modal) {
      new GenericDialog(this.dom.modal as HTMLElement);
    }
  }

  addListeners() {
    this.el.addEventListener('click', this.handleOpenModal.bind(this));
    (this.dom.modal as HTMLDialogElement).addEventListener(
      'close',
      this.handleCloseModal.bind(this)
    );
  }

  handleOpenModal() {
    const modal = this.dom.modal as HTMLDialogElement;
    if (!modal) return;

    const title = modal.querySelector('.generic-dialog__title') as HTMLElement;
    const content = modal.querySelector('.generic-dialog__content') as HTMLElement;

    if (title && content) {
      title.innerHTML = this.el.dataset.title as string;
      content.innerHTML = `<div class="rtf">${this.el.dataset.content}</div>`;
      modal.showModal();
    }
  }

  handleCloseModal() {
    console.log('Modal closed');
  }
}

export default ModalLinkButton;
